/**
 * @file: TaskWorkflowNodeManager.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ITaskManager } from './types';

export class TaskWorkflowNodeManager {
  constructor(readonly taskManager: ITaskManager) {}

  protected get taskNo() {
    return this.taskManager.taskNo;
  }

  protected get taskService() {
    return this.taskManager.taskService;
  }

  protected get inventoryService() {
    return this.taskManager.serviceFactory.inventoryService;
  }

  protected get cachedDetail() {
    return this.taskManager.cachedDetail;
  }

  protected get currentUser() {
    return this.taskManager.currentUser.user;
  }
}
